import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
  AutoAwesome,
  Fullscreen,
  FitScreen,
  Settings,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
  FormatAlignJustify,
  VerticalAlignTop,
  VerticalAlignCenter,
  VerticalAlignBottom,
  ViewColumn,
  ViewModule,
  ViewAgenda,
  WrapText,
  ViewStream,
  SwapVert,
} from "@mui/icons-material";

export const AI_ICON_SVG = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 514" preserveAspectRatio="xMidYMid meet"><g transform="translate(0,514) scale(0.1,-0.1)" fill="currentColor" stroke="none"><path d="M1562 5099 c-58 -29 -82 -70 -127 -214 -88 -284 -163 -361 -430 -440 -144 -42 -176 -57 -209 -98 -25 -31 -31 -49 -34 -102 -4 -55 -1 -70 21 -108 34 -58 50 -67 192 -111 307 -96 368 -158 464 -464 34 -108 48 -139 76 -167 65 -64 166 -71 242 -16 43 31 57 59 103 211 84 276 155 343 460 437 103 31 131 44 161 74 67 66 71 176 8 251 -31 38 -53 48 -204 93 -134 40 -227 86 -280 140 -56 56 -110 166 -154 312 -45 151 -61 178 -134 208 -51 21 -104 19 -155 -6z m178 -967 l-99 -99 -41 51 c-23 28 -65 70 -93 95 -29 24 -52 48 -52 52 0 5 22 27 48 48 27 22 68 65 93 94 l44 55 99 -99 99 -99 -98 -98z"/><path d="M3090 4497 c-59 -19 -103 -74 -124 -152 -33 -122 -125 -400 -167 -502 -181 -437 -433 -629 -1059 -808 -91 -26 -179 -56 -196 -68 -103 -68 -111 -219 -16 -299 19 -15 86 -41 193 -72 530 -155 776 -301 945 -561 96 -148 165 -318 283 -701 36 -115 46 -136 77 -164 45 -39 73 -50 127 -50 60 1 121 31 150 77 14 21 35 76 47 123 60 236 170 525 254 667 172 289 442 457 973 608 70 20 136 39 146 41 24 7 85 61 99 88 45 84 11 208 -70 250 -15 8 -98 34 -184 60 -615 179 -843 341 -1028 727 -44 94 -144 381 -201 579 -38 134 -133 194 -249 157z m138 -942 c122 -248 265 -417 468 -552 77 -52 254 -147 333 -179 22 -9 13 -16 -105 -73 -179 -87 -310 -176 -425 -290 -130 -131 -246 -309 -323 -498 l-22 -52 -82 162 c-94 186 -174 299 -295 413 -127 121 -268 211 -466 298 l-64 29 54 22 c141 58 317 164 435 263 75 63 185 191 249 290 25 40 74 130 108 199 55 115 62 124 71 102 5 -13 34 -73 64 -134z"/><path d="M1498 2201 c-87 -28 -115 -67 -163 -231 -45 -152 -102 -286 -151 -358 -84 -122 -215 -199 -468 -277 -170 -52 -193 -64 -225 -110 -48 -70 -47 -155 3 -220 35 -45 45 -50 200 -97 322 -97 444 -181 539 -373 39 -78 84 -200 117 -320 36 -130 92 -185 188 -185 64 0 121 27 155 72 13 18 39 83 56 143 73 248 155 407 249 482 89 71 199 121 405 183 147 45 167 55 203 110 32 48 36 127 11 176 -24 46 -81 92 -129 104 -24 6 -99 29 -168 51 -266 87 -382 176 -470 361 -27 57 -69 170 -94 252 -46 154 -67 190 -127 222 -36 18 -98 25 -131 15z m88 -783 c50 -81 171 -203 256 -257 l67 -43 -73 -49 c-86 -57 -209 -183 -256 -261 l-34 -56 -48 73 c-61 93 -148 180 -242 243 l-74 50 84 57 c93 63 187 159 241 247 20 32 37 58 38 58 1 0 20 -28 41 -62z"/></g></svg>`;

export enum iconNames {
  notset,
  row,
  row_reverse,
  column,
  column_reverse,
  flex_auto,
  flex_fill,
  flex_hug,
  flex_custom,
  // Justify content
  justify_start,
  justify_center,
  justify_end,
  justify_space_between,
  justify_space_around,
  justify_space_evenly,
  // Align items
  align_start,
  align_center,
  align_end,
  align_baseline,
  align_stretch,
  // Align content
  align_content_start,
  align_content_center,
  align_content_end,
  align_content_space_between,
  align_content_space_around,
  align_content_stretch,
  // Flex wrap
  wrap_nowrap,
  wrap_wrap,
  wrap_wrap_reverse,
}

export const iconMap = {
  [iconNames.row]: ArrowForward,
  [iconNames.row_reverse]: ArrowBack,
  [iconNames.column]: ArrowDownward,
  [iconNames.column_reverse]: ArrowUpward,
  [iconNames.flex_auto]: AutoAwesome,
  [iconNames.flex_fill]: Fullscreen, // Represents filling the container
  [iconNames.flex_hug]: FitScreen, // Represents hugging the content
  [iconNames.flex_custom]: Settings, // Represents custom settings
  // Justify content
  [iconNames.justify_start]: FormatAlignLeft,
  [iconNames.justify_center]: FormatAlignCenter,
  [iconNames.justify_end]: FormatAlignRight,
  [iconNames.justify_space_between]: FormatAlignJustify,
  [iconNames.justify_space_around]: ViewModule,
  [iconNames.justify_space_evenly]: ViewAgenda,
  // Align items
  [iconNames.align_start]: VerticalAlignTop,
  [iconNames.align_center]: VerticalAlignCenter,
  [iconNames.align_end]: VerticalAlignBottom,
  [iconNames.align_baseline]: ViewStream, // baseline
  [iconNames.align_stretch]: Fullscreen,
  // Align content
  [iconNames.align_content_start]: VerticalAlignTop,
  [iconNames.align_content_center]: VerticalAlignCenter,
  [iconNames.align_content_end]: VerticalAlignBottom,
  [iconNames.align_content_space_between]: ViewColumn,
  [iconNames.align_content_space_around]: ViewModule,
  [iconNames.align_content_stretch]: Fullscreen,
  // Flex wrap
  [iconNames.wrap_nowrap]: ViewStream,
  [iconNames.wrap_wrap]: WrapText,
  [iconNames.wrap_wrap_reverse]: SwapVert,
};

export const customJsScript = "data-custom-inc-js";
